var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "field",
    _vm._b({}, "field", { ..._vm.$attrs, ..._vm.$props }, false),
    _vm._l(_vm.optionsWithExpanded, function (option) {
      return _c(
        "div",
        {
          key: option.name,
          staticClass: "_flex _gap-1",
          attrs: { "data-qa": `checkbox-group:${option.index}` },
        },
        [
          _c("base-icon", {
            staticClass: "_tc--accent _cur-p _flex gfu-icon--collapsible",
            attrs: { name: option.iconName, "data-qa": "toggle-expand" },
            on: {
              click: function ($event) {
                return _vm.toggleExpand(option)
              },
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "_flexcol" },
            [
              _c("three-state-checkbox-field", {
                attrs: {
                  value: _vm.parentValue(option),
                  "display-name": option.name,
                  "checked-value": option.name,
                  inline: true,
                  condensed: true,
                  disabled: option.isDisabled,
                  "data-qa": "grouped-checkbox-option",
                },
                on: {
                  input: function ($event) {
                    return _vm.toggleAllSubOptions(option)
                  },
                },
              }),
              _vm._v(" "),
              option.subOptions?.length > 0
                ? _c(
                    "div",
                    {
                      class: [
                        "gfu-collapsible _pa-0 _bd--none",
                        { "gfu-collapsible--expanded": option.expanded },
                      ],
                      attrs: { "data-qa": "grouped-checkbox-suboptions" },
                    },
                    [
                      _c(
                        "div",
                        {
                          class: [
                            "gfu-collapsible__content _pa-0 _bgc--white",
                            {
                              "gfu-collapsible__content--expanded":
                                option.expanded,
                            },
                          ],
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "_flexcol" },
                            _vm._l(option.subOptions, function (subOption) {
                              return _c("checkbox-field", {
                                key:
                                  "grouped-checkbox-sub-item:" +
                                  subOption.value,
                                staticClass: "_pl-5",
                                attrs: {
                                  value: _vm.value,
                                  "display-name": subOption.name,
                                  "checked-value": subOption.value,
                                  inline: true,
                                  disabled: option.isDisabled,
                                  condensed: true,
                                  "data-qa": `grouped-checkbox-sub-item:${subOption.value}`,
                                },
                                on: { input: _vm.onSubOptionInput },
                              })
                            }),
                            1
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }